export default __webpack_public_path__ + "static/media/shape4.a29b2f26.svg";